function getCityByZip(zip,callback){
    if(typeof callback === "undefined"){
        callback = console.log;
    }
    let data = {
        'action': "get_city_by_zip",
        'zip': zip,
    };

    jQuery.ajax({
        method: 'POST',
        url: window.main_theme_objects.ajax_url,
        data: data,
    }).done(callback).fail(callback);
}



//Example
//getCityByZip(5000);

export {getCityByZip};
